import { taskMarkerStyle } from "helpers/map";
import { formatNumber } from "helpers/system";
import React from "react";
import { CircleMarker, Tooltip } from "react-leaflet";

export default function AxisLoadPoint({ axisLoadValue }) {
    if (!axisLoadValue) {
        return null;
    }

    const options = {
        center: [axisLoadValue.location[1], axisLoadValue.location[0]],
        pane: "markerPane",
        ...taskMarkerStyle,
    };
    return (
        <CircleMarker {...options}>
            <Tooltip
                className="map__tooltip-route-marker map__tooltip-route-marker--dark leaflet-tooltip--left-align leaflet-tooltip--light"
                direction="top"
            >
                <div>
                    <div className="pb-2 font-weight-bold">Отклонение нагрузки на ось</div>
                    <strong className="text-muted">Ось 1:</strong> {formatNumber(axisLoadValue.value)} т.
                    <br />
                    <strong className="text-muted">Ось 2:</strong> {formatNumber(axisLoadValue.secondaryValue)} т.
                    <br />
                    <strong className="text-muted">Средний вес:</strong> {formatNumber(axisLoadValue.averageValue)} т.
                    <br />
                    <strong className="text-muted">Вес прицепа:</strong> {formatNumber(axisLoadValue.trailerValue)} т.
                </div>
            </Tooltip>
        </CircleMarker>
    );
}
